class steps {
      constructor(
            id,
            name,
            levelId,
            mandatory,
            enoght
      
      ) {
        this.id = id;
        this.name = name;
        this.levelId = levelId;
        this.mandatory = mandatory == true ? '✔️' : ''
        this.enoght = enoght == true ? '✔️' : '';
       
       
      }
      static fromJson({
            pasoId,
            nombrePaso,
            nivelId,
            obligatorio,
            suficiente
      
      }) {
        return new steps(
       
            pasoId,
            nombrePaso,
            nivelId,
            obligatorio,
            suficiente
          
       
        );
      }
    }
    export default steps;
    